const roles = {
  groupDev: ["fn"],
  groupAdmin: ["fn", "QUO_SUPERUSUARIO"],
  groupRegulador: ["fn", "QUO_SUPERUSUARIO", "QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL"],
  groupReguladorTecnico: ["fn", "QUO_SUPERUSUARIO", "QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL", "QUO_CONTROLADOR_TECNICO"],
  groupUser: ["fn", "QUO_SUPERUSUARIO", "QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL", "QUO_CONTROLADOR_TECNICO", "QUO_USUARIO", "QUO_EXTERNO"],
  groupCommon: ["fn", "QUO_SUPERUSUARIO", "QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL", "QUO_CONTROLADOR_TECNICO", "QUO_USUARIO", "QUO_EXTERNO", "QUO_INTERESSADO"],
  groupCommonExceptReguladorTecnico: ["fn", "QUO_SUPERUSUARIO", "QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL", "QUO_USUARIO", "QUO_EXTERNO", "QUO_INTERESSADO"],
  groupPipeline: ["QUO_SUPERUSUARIO","QUO_CONTROLADOR_GLOBAL", "QUO_CONTROLADOR_LOCAL", "QUO_CONTROLADOR_TECNICO", "QUO_USUARIO"],
  dev: "fn",
  superusuario: "QUO_SUPERUSUARIO",
  reguladorGlobal: "QUO_CONTROLADOR_GLOBAL",
  reguladorLocal: "QUO_CONTROLADOR_LOCAL",
  reguladorTecnico: "QUO_CONTROLADOR_TECNICO",
  usuario: "QUO_USUARIO",
  interessado: "QUO_INTERESSADO",
  externo: "QUO_EXTERNO",
  listaRoles: [
    { label: "superusuario", value: "QUO_SUPERUSUARIO" },
    { label: "controlador", value: "QUO_CONTROLADOR_GLOBAL" },
    { label: "controlador técnico", value: "QUO_CONTROLADOR_TECNICO" },
    // { label: "regulador-local", value: "QUO_CONTROLADOR_LOCAL" },
    { label: "usuario", value: "QUO_USUARIO" },
    { label: "externo", value: "QUO_EXTERNO" },
  ],
};


export default roles;
